document.querySelectorAll('.page-previews__wrapper').forEach((wrapper) => {
    const list = wrapper.querySelector('.page-previews__list')
    const previous = wrapper.querySelector('.page-previews__arrow-back')
    const next = wrapper.querySelector('.page-previews__arrow')
    if (!list || !previous || !next) return

    const maxScroll = () => Math.max(0, list.scrollWidth - list.clientWidth)
    const updateControls = () => {
        const maximum = maxScroll()
        previous.disabled = list.scrollLeft <= 1
        next.disabled = list.scrollLeft >= maximum - 1
        previous.classList.toggle('end', previous.disabled)
        next.classList.toggle('end', next.disabled)
    }

    const move = (direction) => {
        const left = Math.max(0, Math.min(maxScroll(), list.scrollLeft + direction * 260))
        list.scroll({
            left,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        })
    }

    // Native buttons provide Enter and Space activation.
    previous.addEventListener('click', () => move(-1))
    next.addEventListener('click', () => move(1))
    for (const button of [previous, next]) {
        button.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return
            event.preventDefault()
            move(event.key === 'ArrowLeft' ? -1 : 1)
        })
    }

    // Touch, trackpad, keyboard and button scrolling all use the actual position.
    list.addEventListener('scroll', updateControls, { passive: true })
    window.addEventListener('resize', updateControls)
    if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(updateControls)
        observer.observe(list)
        Array.from(list.children).forEach((item) => observer.observe(item))
    }
    updateControls()
})
